export const fetchPostInsights = async (postIds: string[]) => {
  return fetch('/post_insights_v2', {
    method: 'POST',
    body: JSON.stringify({
      post_ids: postIds.join(','),
    }),
    headers: {
      'Sec-Fetch-Dest': 'empty',
    },
  });
};
